import type { Notification } from '@gyym/sdk'
import React from 'react'

import { getUnreadNotificationCount } from '../utils'

export const useUnreadNotificationCount = (notifications: Notification[]) => {
  const [count, setCount] = React.useState(0)

  // Ensure notification counts are loaded in the browser
  React.useEffect(() => {
    setCount(getUnreadNotificationCount(notifications.map(({ id }) => id)))
  }, [notifications])

  return count
}
